import './src/styles/global.scss';
import { wrapWithHocsClient } from './wrap-with-hocs';

export const wrapRootElement = wrapWithHocsClient;
